import React from 'react';
import { Link } from 'react-router-dom';

const IAmClient: React.FC = () => {
  return (
    <div className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold text-center mb-8">Sunt Client</h1>
          
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold mb-4">Beneficii pentru Clienți</h2>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <svg className="w-6 h-6 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Acces la o rețea de profesioniști verificați</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-6 h-6 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Proces simplificat de găsire a consultanților</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-6 h-6 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Evaluări și feedback de la alți clienți</span>
                  </li>
                  <li className="flex items-start">
                    <svg className="w-6 h-6 text-primary mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                    </svg>
                    <span>Suport în toate etapele procesului</span>
                  </li>
                </ul>
              </div>

              <div className="pt-6 border-t">
                <h2 className="text-xl font-semibold mb-4">Cum Funcționează</h2>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      1
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Publică Proiectul</h3>
                      <p className="text-gray-600">Completează formularul cu detaliile proiectului tău</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      2
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Primește Oferte</h3>
                      <p className="text-gray-600">Consultanții calificați îți vor trimite oferte personalizate</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center mr-3 flex-shrink-0">
                      3
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">Alege și Colaborează</h3>
                      <p className="text-gray-600">Selectează cel mai bun consultant și începe colaborarea</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-6 border-t">
                <h2 className="text-xl font-semibold mb-4">Începe Acum</h2>
                <p className="text-gray-600 mb-6">
                  Publică primul tău proiect și începe să primești oferte de la profesioniști calificați.
                </p>
                <div className="flex gap-4">
                  <Link
                    to="/publish-project"
                    className="flex-1 py-3 bg-primary text-white text-center rounded-lg hover:bg-primary-dark transition-colors"
                  >
                    Publică un Proiect
                  </Link>
                  <Link
                    to="/login"
                    className="flex-1 py-3 bg-white text-primary border border-primary text-center rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    Autentificare
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IAmClient; 